<template>
  <BaseItem
      ref="TaskTemplateItem"
      :item-uid="itemUid"
      :subtract-height="subtractHeight"
      parentComponent="TaskTemplateTable"
      dto-detail-model="TaskTemplateDetailQueryDTO"
      dto-save-model="TaskTemplateSaveCommandDTO"
      dto-restore-model="TaskTemplateRestoreCommandDTO"
      dto_validate_model="TaskTemplateValidateCommandDTO"
      dto-filter-restore-model="TaskTemplateDetailResponseDTO"
      :store-name="store_name"
      :modal-dialog="modalDialog"
      :routeFullScreen="routeFullScreen"
  >
    <template v-slot:body="{editedItem, editedItemCommon, slotHeight, lockPage, fetchAction, changed}">
      <v-row>
        <v-col cols="4">
          <v-text-field
              v-model="editedItem.name"
              :label="$t('columns.name')"
              outlined
              dense
              :counter="50"
              required
              :filled="lockPage"
              :readonly="lockPage"
              class="mb-n5 ml-3"
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
              v-model="editedItem.description"
              :label="$t('columns.description')"
              outlined
              dense
              rows="2"
              :filled="lockPage"
              :readonly="lockPage"
              class="mb-n5 ml-3 mr-3"
          >
          </v-textarea>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <TaskCard
              :component-height="slotHeight - 220"
              v-if="!!editedItem"
              :item-list="editedItem.task_template_ones"
              :common="editedItemCommon"
              :readonly="lockPage"
              :show-deleted="!!editedItem.page_properties ? editedItem.page_properties.show_deleted : true"
              :dto_import_library_doc_model="dto_import_library_doc_model"
              :fetch-action="fetchAction"
              :parent-edited-item="editedItem"
              :parent-changed="changed"
          >
          </TaskCard>
        </v-col>
      </v-row>
    </template>
  </BaseItem>
</template>

<script>
// import {mapGetters, mapActions} from 'vuex';
// import {mapFields} from 'vuex-map-fields';
import ConfirmDialog from "@/components/Base/ConfirmDialog";
import BaseTable from "@/components/Base/BaseTable";
import commonFunction from "@/commonFunction/commonFunction"
import BaseItem from "@/components/Base/BaseItem";
import {v4 as uuidv4} from "uuid";
import BaseCardList from "@/components/Base/BaseCardList";
import LibraryDocCardList from "@/components/Product/Old/LibraryDocCardList";
import TaskCard from "@/components/Product/Task/TaskCard";
import {mapActions} from "vuex";


export default {
  name: 'TaskTemplateItem',
  props: {
    subtractHeight: {type: [Number], default: 40},
    height: {type: [Number], default: window.innerHeight},
    itemUid: {default: null},
    dto_import_library_doc_model: {type: [String], default: 'TaskTemplateImportFromLibraryDocCommandDTO'},
    store_name: {type: [String], default: 'TaskTemplateTable'},
    modalDialog: {type: [Boolean], default: false},
    routeFullScreen: {type: [Object], default: null},
  },

  components: {
    ConfirmDialog,
    BaseItem,
    BaseTable,
    BaseCardList,
    LibraryDocCardList,
    TaskCard,
  },

  computed: {},



  methods: {
    ...mapActions('ProductTable', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchAction',
      'fetchSaveEditedItem', 'fetchRequest']),
  },

  async mounted() {
  }
  ,

  data() {
    return {
    }
  }
}
</script>

<style>
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n src=".\locales.json">
</i18n>
